import {
    GETBUSINESSNATURETABLELIST_SUCCESS,
    GETBUSINESSNATURETABLELIST_FAILED,
    RESET_GETBUSINESSNATURETABLELIST,
    LOADING_GETBUSINESSNATURETABLELIST,
    NETWORK_ERROR_GETBUSINESSNATURETABLELIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETBUSINESSNATURETABLELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETBUSINESSNATURETABLELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETBUSINESSNATURETABLELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETBUSINESSNATURETABLELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETBUSINESSNATURETABLELIST:
            return (state = initialState);
        default:
            return state;
    }
};
